import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { deepCopy } from 'deep-copy-ts';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { SimulationQuery } from '../state/simulation.query';
import { SimulationService } from '../state/simulation.service';

@Component({
  selector: 'app-simulation-collective-classification',
  templateUrl: './simulation-collective-classification.component.html',
  styleUrls: ['./simulation-collective-classification.component.scss']
})
export class SimulationCollectiveClassificationComponent implements OnInit {

  form: FormGroup;

  constructor(
    private simulationQuery: SimulationQuery,
    private simulationService: SimulationService,
    private fb: FormBuilder,
    private windowService: WindowService,
    private snakBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    const simulation = this.simulationQuery.getActive();
    this.form = this.fb.group({
      min_collective_horiz: [simulation.min_collective_horiz, [Validators.required, Validators.min(1)]],
      min_collective_vert: [simulation.min_collective_vert, [Validators.required, Validators.min(1)]]
    });
  }

  save(): void {
    const simulation = {
      ...deepCopy(this.simulationQuery.getActive()),
      ...this.form.value
    }
    this.simulationService.update(this.simulationQuery.getActiveId(), simulation)
      .subscribe((simulation) => {
        this.snakBar.open($localize`Simulation ${simulation.name} update`, null, { duration: 2000 });
        this.windowService.close(this);
      });
  }

}
